import React from 'react';
//import axios from 'axios';
import API from './api';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './Login';
import DashboardAdmin from './DashboardAdmin';
import DashboardTeacher from './DashboardTeacher';
import ForceLogoutRedirect from './ForceLogoutRedirect';
import VisitQRConfirm from './VisitQRConfirm';
import VisitConfirmPage from './VisitConfirmPage';
import ReportPrint from './ReportPrint';
import useVersionRefresh from './useVersionRefresh';
import VersionBanner from './VersionBanner';
import MagicLogin from './MagicLogin';

// Axios interceptor koji reaguje na istekao token
//API.interceptors.response.use(
//  response => response,
//  error => {
//    const status = error.response?.status;
//    if (status === 401 || status === 403) {
//      localStorage.clear();
//      window.location.href = '/login';
//    }
//    return Promise.reject(error);
//  }
//);

const ProtectedRoute = ({ children, role }) => {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const location = JSON.parse(localStorage.getItem('location') || 'null');

  if (!token || !location) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to="/login" replace />;

  return children;
};

const App = () => {
  const basePath =
    (import.meta && import.meta.env && import.meta.env.BASE_URL) || // Vite
    process.env.PUBLIC_URL || // CRA
    '/';
  const { outdated, reload } = useVersionRefresh({ intervalMs: 60000, basePath });
  return (
    <Router basename={basePath !== '/' ? basePath : undefined}>
	  {outdated && <VersionBanner onReload={reload} />}
      <Routes>
        <Route path="/login" element={<Login />} />
	    <Route path="/" element={<Navigate to="/login" replace />} />
	  
	    {/* Magic link login (bez zaštite) */}
	    <Route path="/magic-login" element={<MagicLogin />} />

        <Route
          path="/admin/*"
          element={
            <ProtectedRoute role="admin">
              <DashboardAdmin />
            </ProtectedRoute>
          }
        />

        <Route
          path="/teacher/*"
          element={
            <ProtectedRoute role="teacher">
              <DashboardTeacher />
            </ProtectedRoute>
          }
        />
		
	  {/* NEZAŠTIĆENE rute dostupne roditeljima (bez tokena) */}
	  
	  <Route path="/visit/:id/qr" element={<VisitQRConfirm />} />
	  <Route path="/visit/:id/confirm" element={<VisitConfirmPage />} />
	  <Route path="/report/:id" element={<ReportPrint />} />

        {/* Fallback: ako je ruta nepoznata */}
        <Route path="*" element={<ForceLogoutRedirect />} />
      </Routes>
    </Router>
  );
};

export default App;

